import { TextField, withStyles } from "@material-ui/core";
import { displayValue } from "utils/randomKey";
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  formControl: {
    width: 220,
    marginTop: "10px",
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "red",
    },
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  variant: "menu",
};
export const CustomTextField = withStyles((theme) => ({
  root: {
    width: "100%",
    height: "2em",
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#4f2d7f", // border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "#4f2d7f", // border color on focus
      },
    },
  },
}))(TextField);

export const rowStyle2 = (row, rowIndex) => {
  const style = {};
  style.backgroundColor = "#fff";
  return style;
};
export const commonStyle = {
  fontFamily: "Gt-Walsheim-medium",
  fontSize: "11px",
  fontWeight: "bold",
  textAlign: "center",
  textWrap: "wrap",
  wordBreak: "break-word",
  verticalAlign: "middle", // Center-align text vertically
  // borderRight:'1px solid black'
};

export const commonHeaderStyle = {
  fontFamily: "Gt-Walsheim-medium",
  fontSize: "12px",
  fontWeight: "bold",
  verticalAlign: "text-top",
  backgroundColor: "#4f2d7f",
  color: "#fff",
  textWrap: "wrap",
  wordBreak: "break-word",
  // borderRight:'1px solid black'
};

export const displayNullFormatter = (row, property) => {
  return (
    <>
      {row[property] === null ||
      row[property] === undefined ||
      row[property] === ""
        ? "--"
        : row[property]}
    </>
  );
};

export const displayCommaFormatter = (row, property) => {
  return (
    <>
      {row[property] === null ||
      row[property] === undefined ||
      row[property] === ""
        ? "--"
        : displayValue(Number(row[property]))}
    </>
  );
};

export const dataTypes = [
  {
    label: "All",
    value: "All",
    tagClassName: "special",
    checked: true,
    children: [
      {
        label: "B2B",
        value: "B2B",
      },
      {
        label: "B2BA",
        value: "B2BA",
      },
      {
        label: "CDN",
        value: "CDN",
      },
      {
        label: "CDNA",
        value: "CDNA",
      },
      { label: "IMPG", value: "IMPG" },
      { label: "IMPGSEZ", value: "IMPGSEZ" },
      { label: "ISD", value: "ISD" },
      { label: "ISDA", value: "ISDA" },
    ],
  },
];
export const dataTypesViewTab = [
  {
    label: "B2B",
    value: "B2B",
  },
  {
    label: "B2BA",
    value: "B2BA",
  },
  {
    label: "CDN",
    value: "CDN",
  },
  {
    label: "CDNA",
    value: "CDNA",
  },
  { label: "IMPG", value: "IMPG" },
  { label: "IMPGSEZ", value: "IMPGSEZ" },
  { label: "ISD", value: "ISD" },
  { label: "ISDA", value: "ISDA" },
];
export const recoStatus = [
  {
    label: "Matched",
    value: "Matched",
  },
  {
    label: "Mismatched",
    value: "Mismatched",
  },
  {
    label: "Probable Match",
    value: "Probable Match",
  },
  {
    label: "Not in GSTN",
    value: "Not in GSTN",
  },
  {
    label: "Not in PR",
    value: "Not in PR",
  },
];

export const markIn3b = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];
export function extractMonthsInRangeMMYYYY(startDate, endDate) {
  const startYear = startDate?.getFullYear();
  const endYear = endDate?.getFullYear();
  const startMonth = startDate?.getMonth();
  const endMonth = endDate?.getMonth();

  const months = [];

  for (let year = startYear; year <= endYear; year++) {
    const monthStart = year === startYear ? startMonth : 0;
    const monthEnd = year === endYear ? endMonth : 11;

    for (let month = monthStart; month <= monthEnd; month++) {
      months.push(`${(month + 1).toString().padStart(2, "0")}${year}`);
    }
  }

  return months;
}
export function areMonthsInTwoFinancialYears(months) {
  if (!Array.isArray(months) || months.length === 0) return false;

  // Extract years from the input
  const yearsSet = new Set();
  months.forEach((month) => {
    const year = parseInt(month.slice(-4), 10);
    const monthPart = parseInt(month.slice(0, 2), 10);

    // Financial year adjustment: months Jan, Feb, Mar belong to the previous year's FY
    if (monthPart >= 1 && monthPart <= 3) {
      yearsSet.add(year - 1);
    } else {
      yearsSet.add(year);
    }
  });

  // Convert Set to sorted array of years
  const yearsArray = Array.from(yearsSet).sort((a, b) => a - b);

  // Check if the years are within two consecutive financial years
  return (
    yearsArray.length <= 2 &&
    (yearsArray.length < 2 || yearsArray[1] - yearsArray[0] === 1)
  );
}

export function getLastDateOfMonth(date) {
  // Create a new date object based on the input date
  let inputDate = new Date(date);

  // Set the date to the first day of the next month
  let lastDate = new Date(inputDate.getFullYear(), inputDate.getMonth() + 1, 0);

  return lastDate;
}

// export function getStartDate(yearRange) {
//   const match = yearRange.match(/^(\d{4})-(\d{2})$/); // Match format YYYY-YY
//   if (!match) {
// return
//     // throw new Error("Invalid input format. Expected format: YYYY-YY");
//   }

//   const startYear = match[1]; // Extract the first year
//   const startDate = new Date(`${startYear}-04-01T00:00:00Z`);

//   if (isNaN(startDate.getTime())) {
//     throw new Error("Invalid start date. Check the input format.");
//   }
//   console.log("264 :: ", startDate.toISOString());
//   return startDate.toISOString();
// }
export function getStartDate(yearRange) {
  // Match format YYYY-YY
  const match = yearRange.match(/^(\d{4})-(\d{2})$/);
  if (!match) {
    return
    // throw new Error("Invalid input format. Expected format: YYYY-YY");
  }

  // Extract the first year from the match
  const startYear = match[1];
  const startDate = new Date(`${startYear}-04-01T00:00:00Z`);

  // Validate the startDate object
  if (isNaN(startDate.getTime())) {
    throw new Error("Invalid start date. Check the input format.");
  }

  // Return the startDate as a localized string
  return startDate.toString(); // Returns a localized date string
}
export function getEndDate(yearRange) {
  // Match format YYYY-YY
  const match = yearRange.match(/^(\d{4})-(\d{2})$/);
  if (!match) {
    return
    // throw new Error("Invalid input format. Expected format: YYYY-YY");
  }

  // Extract the first year as an integer
  const startYear = parseInt(match[1], 10);
  const endYear = startYear + 1; // Calculate the second year (YYYY + 1)
  
  // Construct the end date
  const endDate = new Date(`${endYear}-03-31T00:01:00Z`);

  // Validate the endDate object
  if (isNaN(endDate.getTime())) {
    throw new Error("Invalid end date. Check the input format.");
  }

  // Return the endDate as a localized string
  return endDate.toString(); // Returns a localized date string
}
export function extractMonthsInRange(startDate, endDate) {
  const startYear = startDate?.getFullYear();
  const endYear = endDate?.getFullYear();
  const startMonth = startDate?.getMonth();
  const endMonth = endDate?.getMonth();
  
  const months = [];
  
  for (let year = startYear; year <= endYear; year++) {
      const monthStart = (year === startYear) ? startMonth : 0;
      const monthEnd = (year === endYear) ? endMonth : 11;
      
      for (let month = monthStart; month <= monthEnd; month++) {
          months.push(`${(month + 1).toString().padStart(2, '0')}-${year}`);
      }
  }
  
  return months;
}
// export function getEndDate(yearRange) {
//   const match = yearRange.match(/^(\d{4})-(\d{2})$/);
//   if (!match) {
//     return
//     // throw new Error("Invalid input format. Expected format: YYYY-YY");
//   }

//   const startYear = parseInt(match[1], 10); // Extract the first year as an integer
//   const endYear = startYear + 1; // Calculate the second year (YYYY + 1)
//   const endDate = new Date(`${endYear}-03-31T00:01:00Z`); // Construct end date

//   if (isNaN(endDate.getTime())) {
//     throw new Error("Invalid end date. Check the input format.");
//   }

//   console.log("283 :: ", endDate.toISOString());
//   return endDate.toISOString();
// }

export function getMonthName(dateString) {
  // Extract the month number from the string
  const [month, year] = dateString.split("-");

  // Define array of month names (0-based index)
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // Convert to 0-based index and return month name
  const monthIndex = parseInt(month, 10) - 1;
  return monthNames[monthIndex] || "Invalid month";
}

export function getFinancialYearStartDate(initialStartDate) {
  if (!initialStartDate) {
    throw new Error("Initial start date is required.");
  }
  
  const date = new Date(initialStartDate);
  if (isNaN(date.getTime())) {
    throw new Error("Invalid start date.");
  }
  
  const month = date.getMonth(); // 0-based
  const year = month < 3 
    ? date.getFullYear() - 1 
    : date.getFullYear();
    
  // Return April 1 of the financial year
  return new Date(year, 3, 1, 0, 0, 0, 0);
}
export function getFinancialYearEndDate(initialEndDate) {
  if (!initialEndDate) {
    throw new Error("Initial end date is required.");
  }
  
  const date = new Date(initialEndDate);
  if (isNaN(date.getTime())) {
    throw new Error("Invalid end date.");
  }
  
  const month = date.getMonth();
  const year = month < 3 
    ? date.getFullYear() 
    : date.getFullYear() + 1;
  
  // Return March 31 of the financial year
  return new Date(year, 2, 31, 0, 0, 0, 0);
}

export function addUniqueKeysSupplierWise(data) {
    return data.map((row, index) => {
        const category = (row.CATEGORY == null || row.CATEGORY === "") ? "Nil" : row.CATEGORY;
        const gstin = (row.GSTIN == null || row.GSTIN === "") ? "Nil" : row.GSTIN;
        const gstinPurchase = (row.GSTIN_PURCHASE == null || row.GSTIN_PURCHASE === "") ? "Nil" : row.GSTIN_PURCHASE;

        return {
            ...row,
            uniqueKey: `${index}_${category}_${gstin}_${gstinPurchase}`
        };
    });
}
export function addUniqueKeysDocView(data) {
    return data.map((row, index) => {
        const category = (row.CATEGORY == null || row.CATEGORY === "") ? "Nil" : row.CATEGORY;
        const gstin = (row.GSTIN == null || row.GSTIN === "") ? "Nil" : row.GSTIN;
        const gstinPurchase = (row.GSTIN_PURCHASE == null || row.GSTIN_PURCHASE === "") ? "Nil" : row.GSTIN_PURCHASE;

        return {
            ...row,
            uniqueKey: `${index}_${category}_${gstin}_${gstinPurchase}`
        };
    });
}
